import PageHero from "@/components/base/PageHero";
import LegalBlock from "@/components/base/LegalBlock";
import { company } from "@/mocks/site";

export default function Datenschutz() {
  return (
    <>
      <PageHero
        label="Rechtliches"
        title="Datenschutz"
        lead="Wir behandeln Ihre Daten vertraulich und verarbeiten personenbezogene Angaben ausschließlich im Rahmen der gesetzlichen Bestimmungen."
      />

      <section className="bg-background-50 py-10 md:py-16">
        <div className="mx-auto w-full max-w-shell px-4 md:px-6">
          <div className="max-w-3xl">
            <LegalBlock title="1. Verantwortliche Stelle">
              <p>
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p>
                {company.name}
                <br />
                {company.street}, D-{company.zip} {company.city}
                <br />
                Telefon: {company.phone} · E-Mail:{" "}
                <a href={`mailto:${company.email}`} className="text-primary-700 underline underline-offset-2">
                  {company.email}
                </a>
              </p>
            </LegalBlock>

            <LegalBlock title="2. Erhebung und Verarbeitung von Daten">
              <p>
                Beim Aufruf unserer Website werden technisch notwendige Informationen in
                Server-Logfiles erfasst (Browsertyp, Betriebssystem, aufgerufene Seite, Uhrzeit des
                Zugriffs). Diese Angaben lassen keine Rückschlüsse auf Ihre Person zu und dienen
                ausschließlich der technischen Bereitstellung und Sicherheit der Website.
              </p>
              <p>
                Wenn Sie unser Kontaktformular oder unsere E-Mail-Adresse nutzen, verarbeiten wir
                die von Ihnen angegebenen Daten (Name, Firma, E-Mail-Adresse, Telefonnummer,
                Anliegen, Nachricht), um Ihre Anfrage zu bearbeiten.
              </p>
            </LegalBlock>

            <LegalBlock title="3. Rechtsgrundlage">
              <p>
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
                (vorvertragliche Maßnahmen bzw. Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO
                (berechtigtes Interesse an einem sicheren Betrieb der Website). Soweit Sie
                eingewilligt haben, ist Art. 6 Abs. 1 lit. a DSGVO die Rechtsgrundlage.
              </p>
            </LegalBlock>

            <LegalBlock title="4. Speicherdauer">
              <p>
                Wir speichern Ihre Angaben nur so lange, wie es für die Bearbeitung der Anfrage
                erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Danach werden die
                Daten gelöscht.
              </p>
            </LegalBlock>

            <LegalBlock title="5. Weitergabe an Dritte">
              <p>
                Eine Weitergabe Ihrer Daten erfolgt nicht zu Werbezwecken. Daten werden nur
                weitergegeben, wenn dies gesetzlich vorgeschrieben ist oder für die Abwicklung eines
                Auftrags erforderlich ist (z. B. Versand oder Montage).
              </p>
            </LegalBlock>

            <LegalBlock title="6. Kartendarstellung">
              <p>
                Auf der Kontaktseite ist eine Karte des Dienstes Google Maps eingebunden. Beim Laden
                der Karte werden Ihre IP-Adresse und weitere technische Informationen an Google
                übertragen. Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, Dublin
                4, Irland. Weitere Informationen finden Sie in der Datenschutzerklärung von Google.
              </p>
            </LegalBlock>

            <LegalBlock title="7. Cookies und Tracking">
              <p>
                Diese Website setzt keine Marketing- oder Analyse-Cookies ein. Es werden keine
                Werkzeuge zur Reichweitenmessung oder zur Profilbildung verwendet.
              </p>
            </LegalBlock>

            <LegalBlock title="8. Ihre Rechte">
              <p>
                Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO),
                Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO),
                Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch (Art. 21 DSGVO). Eine erteilte
                Einwilligung können Sie jederzeit für die Zukunft widerrufen. Zudem steht Ihnen ein
                Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu.
              </p>
            </LegalBlock>

            <LegalBlock title="9. Kontakt in Datenschutzfragen">
              <p>
                Bei Fragen zur Verarbeitung Ihrer Daten erreichen Sie uns unter{" "}
                <a href={`mailto:${company.email}`} className="text-primary-700 underline underline-offset-2">
                  {company.email}
                </a>{" "}
                oder telefonisch unter {company.phone}.
              </p>
            </LegalBlock>

            <p className="border-t border-foreground-200 py-6 font-label text-[10.5px] uppercase tracking-[0.14em] text-foreground-400">
              Stand: {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}